// @ts-strict-ignore
import { Vector3 } from 'three';
import { Connection } from '@3d-scene/model3d/connection';
import { Rectangle3D } from '@3d-scene/model/rectangle-3d';
import { ConnectionInfoUtils } from './util/connection-info-utils';

export class ConnectionSortGroup {
  private static readonly SORT_OFFSET: number = -100000;

  public sortDirection: Vector3;
  public normalDirection: Vector3;
  public connectionCubes: Connection[] = [];

  public get connectionFirstPoint(): Vector3 {
    if (this.connectionCubes.length === 0) {
      return null;
    }
    const targetCube: Connection = this.connectionCubes[0];
    const targetRectangle: Rectangle3D = targetCube.compositionRectangle;
    return targetRectangle.point1;
  }

  public sortConnections(): Connection[] {
    const sortPoint: Vector3 = this.sortDirection.clone();
    sortPoint.multiplyScalar(ConnectionSortGroup.SORT_OFFSET);
    this.connectionCubes = ConnectionInfoUtils.sortConnectionsByPoint(this.connectionCubes, sortPoint, true);
    return this.connectionCubes;
  }

  public get connectionFirstRectangle(): Rectangle3D {
    if (this.connectionCubes.length === 0) {
      return null;
    }
    const targetCube: Connection = this.connectionCubes[0];
    return targetCube.compositionRectangle;
  }
}
